import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import { BrowserStatisticsTitle, ThisYearStatistics, ViewMore } from '../../../Constant';
import ApexCharts from 'react-apexcharts';
import { BrowserStatisticsData, progressOptions } from '../../../Data/DashBoard/Ecommerce/ApexChart';

const BrowserStatistics = () => {
  const ApexProgressChart = () => {
    return BrowserStatisticsData.map((item, i) => {
      const newOptions = {
        ...progressOptions,
        title: {
          ...progressOptions.title,
          text: item.series[0].name,
        },
        subtitle: {
          ...progressOptions.subtitle,
          text: `${item.series[0].data[0]}%`,
        },
      };
      return <ApexCharts key={i} options={newOptions} type='bar' series={item.series} height={75} />;
    });
  };

  return (
    <Col xl='4' md='6' className='box-col-4'>
      <Card className='browser-statistics'>
        <CardHeader className='pb-0 card-no-border dflex justify-content-between'>
          <H5>{BrowserStatisticsTitle}</H5>
          <div className='center-content'>
            <P>{ThisYearStatistics}</P>
          </div>
        </CardHeader>
        <CardBody className='text-center'>
          <ApexProgressChart />
          <Link className='btn btn-primary' to={`${process.env.PUBLIC_URL}/widget/chart-widget`}>
            {ViewMore}
          </Link>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BrowserStatistics;
